module.exports = __webpack_public_path__ + "img/fact-check-black-24-dp.ac6e4643.svg";